module.exports = {
    // baseurl: "/property-owners-guyana/",
    baseurl: "/",    
    loginurl: 'dashboard',
    loginurluser: 'userdashboard',
    uservehicle: 'uservehicle',
    explorer: 'explorer',
    }